const t = (e) => e.websocket;
export {
  t as getWebsocket
};
